var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user"},[_c('img',{attrs:{"src":require("../../assets/images/code-planet.jpg")}}),_c('div',{staticClass:"text"},[_vm._v("个人中心尚未开通，可扫码进入小程序")])])
}]

export { render, staticRenderFns }